import { mapGetters, mapMutations } from "vuex";
import alertHelper from "@/helper/AlertHelper";
import Common from "@/common";

export const shaparakFinalMixin = {
  data() {
    return {
      paymentId: "",
      creditCardInfo: [
        { length: 4, value: "" },
        { length: 4, value: "" },
        { length: 4, value: "" },
        { length: 4, value: "" },
      ],
      options: [],
      selectedAmount: null,
      creditCardPassword: "",
      creditCardCVV2: "",
      creditCardExpireDateMonth: "",
      creditCardExpireDateYear: "",
      securityCode: "",
      email: "",
      passwordRequestSend: false,
      passwordRequestPending: false,
      bankImageSource: "",
      checkIfInputNotEmpty: false,
      secondContainerVisibility: false,
      fixShaparakCreditCardNumber: [
        { length: 4, value: "" },
        { length: 4, value: "" },
        { length: 4, value: "" },
        { length: 4, value: "" },
      ],
      checkTxStatusInterval: null,
      checkUrl: "",
      timestamp: "",
      userRequestedPassword: false,
    };
  },
  computed: {
    ...mapGetters([
      "getShaparakPayingAmount",
      "getStepperPage",
      "getShaparakCompleteCreditCardNumber",
      "getPaymentSuccess",
      "getVersion",
      "getRefNumber",
      "getTransactionId",
      "getMobileLayout",
    ]),
    creditCardMonthExpireValidation() {
      return (
        this.creditCardExpireDateMonth <= 12 &&
        this.creditCardExpireDateMonth.length === 2 &&
        this.creditCardExpireDateYear.length === 2
      );
    },
  },
  methods: {
    ...mapMutations([
      "setShaparakPayingAmount",
      "setStepperPage",
      "setShaparakCallBackUrl",
      "setPaymentSuccess",
      "setShaparakTransactionRefNumber",
      "setTransactionCompleteTime",
    ]),
    getShaparakCreditCardNum() {
      const creditCardArray =
        this.getShaparakCompleteCreditCardNumber.match(/.{1,4}/g) ?? [];
      this.fixShaparakCreditCardNumber = this.fixShaparakCreditCardNumber.map(
        (item, i) => ({
          ...item,
          value: creditCardArray[i],
        })
      );

      [this.checkIfInputNotEmpty, this.bankImageSource] = Common.checkWhatBank(
        this.fixShaparakCreditCardNumber
      );
    },

    expiredPasswordRequestAction() {
      this.passwordRequestSend = false;
    },
    activateTimerEvent(key) {
      setTimeout(() => {
        if (this.$refs[key]) this.$refs[key].activeInterval();
      }, 1);
    },
    deactivateTimerEvent(key) {
      setTimeout(() => {
        if (this.$refs[key]) this.$refs[key].clearInterval();
      }, 1);
    },
    getCreditCardPass() {
      const creditCardExp = this.creditCardExpireDateYear.concat(
        this.creditCardExpireDateMonth
      );
      if (
        creditCardExp.length < 4 ||
        this.creditCardCVV2 === "" ||
        !this.creditCardMonthExpireValidation
      ) {
        alertHelper.errorAlert(
          "",
          "تاریخ و شماره شناسایی دوم را به درستی وارد کنید"
        );
        return;
      }
      this.passwordRequestPending = true;
      const apiBody = {
        cvv2: this.creditCardCVV2,
        exp: creditCardExp,
      };
      this.$http
        .post(`shetab/${this.getTransactionId}/request-pin`, apiBody)
        .then(
          () => {
            alertHelper.successAlert(
              "",
              "درخواست شما برای بانک صادر کننده ارسال شد",
              1500
            );
            this.passwordRequestPending = false;
            this.passwordRequestSend = true;
            this.userRequestedPassword = true;
            this.activateTimerEvent("PasswordRequest");
          },
          (error) => {
            this.deactivateTimerEvent("PasswordRequest");
            this.passwordRequestSend = false;
            this.passwordRequestPending = false;
            alertHelper.errorAlert("", error.body.message);
          }
        );
    },

    hardErrorAlertHandler(title, msg) {
      alertHelper
        .hardErrorAlert(title, msg, 10000, "متوجه شدم", false)
        .then(() => {
          this.setStepperPage("pageOne");
        });
    },
    startCheckingTxResult() {
      this.checkTxStatusInterval = setInterval(() => {
        this.$http.get(this.checkUrl).then(
          (result) => {
            if (
              result.data.data &&
              result.data.data.status !== "PENDING_GATEWAY" &&
              result.data.data.status !== "IN_GATEWAY"
            ) {
              if (result.data.data.status === "SUCCESS") {
                clearInterval(this.checkTxStatusInterval);
                alertHelper.successAlert("", "پرداخت با موفقیت انجام شد");
                const shaparakResult = result.data.data.shetab_result.transfer;
                this.setTransactionCompleteTime(shaparakResult.transferTime);
                if (shaparakResult.refNumber) {
                  this.setShaparakTransactionRefNumber(
                    shaparakResult.refNumber
                  );
                } else if (shaparakResult.traceNumber) {
                  this.setShaparakTransactionRefNumber(
                    shaparakResult.traceNumber
                  );
                }
                this.transactionSuccess();
              } else if (result.data.data.status === "FAILED") {
                clearInterval(this.checkTxStatusInterval);
                this.hardErrorAlertHandler(
                  "",
                  result.data.data.shetab_result.userMessage
                );
                this.transactionFailedAction();
              } else {
                this.hardErrorAlertHandler();
                this.transactionFailedAction();
              }
            }
          },
          (error) => {
            // clearInterval(this.checkTxStatusInterval);
            /*this.$swal.fire({
                icon: 'error',
                showConfirmButton: true,
                timer: 10000,
                confirmButtonText: 'متوجه شدم',
                text: error.body.message,
              });
              this.$store.state.paymentSuccess = false;
              this.$router.push('/shetab/final?id=' + this.paymentId);*/
            console.log(error);
          }
        );
      }, 4000);
    },

    finalTransferShaparakSubmit() {
      const creditCardExp = this.creditCardExpireDateYear.concat(
        this.creditCardExpireDateMonth
      );
 
      if (
        this.creditCardPassword === "" ||
        this.creditCardCVV2 === "" ||
        !this.creditCardMonthExpireValidation ||
        creditCardExp.length < 4
      ) {
        alertHelper.errorAlert("", "لطفا تمامی فیلد ها را به درستی پر کنید");
        return;
      }
      if (!this.userRequestedPassword) {
        alertHelper.errorAlert("", " برای ادامه پرداخت، درخواست رمز دوم اجباری می‌باشد");
        return;
      }
      alertHelper.loadingAlert(
        "لطفا منتظر بمانید و تا زمان مشخص شدن نتیجه تراکنش، این صفحه را رفرش نکنید"
      );
      const passReqApiBody = {
        cvv2: this.creditCardCVV2,
        exp: creditCardExp,
      };
      const transactionId = this.getTransactionId;
      this.$http
        .post(`shetab/${transactionId}/request-transfer`, {
          ...passReqApiBody,
          pin_code: this.creditCardPassword,
        })
        .then(
          (result) => {
            if (result.data.data && result.data.data.check_url) {
              this.setShaparakCallBackUrl(
                result.data.data.payment.callback_url
              );
              this.checkUrl = result.data.data.check_url;
              this.startCheckingTxResult();
            }
          },
          (error) => {
            alertHelper.closeAlert();
            alertHelper.apiErrorAlert("", error.body.message);
            this.transactionFailedAction();
          }
        );
    },
    transactionFailedAction() {
      this.setPaymentSuccess(false);
      this.setStepperPage("pageThree");
    },
    transactionSuccess() {
      this.setPaymentSuccess(true);
      this.setStepperPage("pageThree");
    },

    expiredTransactionTimerAction() {
      this.transactionFailedAction();
      this.timerExpiredAlert();
    },
    timerExpiredAlert() {
      this.$swal({
        title: "توجه",
        text: "مدت زمان پرداخت  6 دقیقه میباشد",
        icon: "danger",
        showConfirmButton: true,
        confirmButtonText: "متوجه شدم",
        customClass: {
          title: "alertTitleClass",
        },
        preConfirm: () => {
          this.setStepperPage("pageOne");
        },
      });
    },
    deactiveAllTimers() {
      this.deactivateTimerEvent("Transaction");
      this.deactivateTimerEvent("PasswordRequest");
    },
  },
  watch: {
    // Auto Focus (Auto Tab) When The Fields Are Full
    creditCardExpireDateMonth(value) {
      if (value.length === 2) {
        document.getElementById("expireDateYearInput").focus();
      }
    },
    creditCardExpireDateYear(value) {
      if (value.length === 2) {
        document.getElementById("creditCardPasswordInput").focus();
      }
    },
    creditCardCVV2(value) {
      if (value.length === 4) {
        document.getElementById("expireDateMonthInput").focus();
      }
    },
    getStepperPage(value) {
      if (value === "pageTwo") this.getShaparakCreditCardNum();
    },
  },
  created() {
    this.getShaparakCreditCardNum();
  },
  mounted() {
    this.activateTimerEvent("Transaction");
  },
  destroyed() {
    this.deactiveAllTimers();
  },
};
